import request from '@/utils/request'

export function exportAllocateTasks (params) {
  return request({
    url: 'exportAllocateTasks',
    method: 'get',
    params
  })
}

export function exportOverdueForm (params) {
  return request({
    url: 'exportOverdueForm',
    method: 'get',
    params
  })
}

export function exportoutsourcedTasks (params) {
  return request({
    url: 'exportoutsourcedTasks',
    method: 'get',
    params
  })
}
